@if (display === INPUT) {
  <mat-form-field class="w-100">
    <mat-label>{{ setting.caption }}</mat-label>
    @if (setting.choices.length == 0) {
      <input matInput [formControl]="control" (change)="valueChanged()">
    }
    @if (setting.choices.length > 0) {
      <mat-select [formControl]="control" (selectionChange)="valueChanged()">
        @for (option of setting.choices; track option) {
          <mat-option [value]="option.value">
            {{ option.name }}
          </mat-option>
        }
      </mat-select>
    }
    <mat-hint>{{ setting.hint }}</mat-hint>
  </mat-form-field>
}

@if (display === CARD) {
  <div class="card-setting w-100">
    <dl>
      <dt>{{ setting.caption }}</dt>
      <dd>
        @if (value$ | async) {
          <app-shipment-card [card]="value$ | async"></app-shipment-card>
        }
      </dd>
    </dl>
    <button mat-button i18n>CLEAR</button>
    <button mat-button (click)="editCard()" i18n>EDIT</button>
  </div>
}

@if (display === AVATAR) {
  <div class="avatar w-100" title="{{ value$ | async }}">
    <app-profile-avatar></app-profile-avatar>
    <button mat-button (click)="uploadAvatar()" i18n>UPLOAD NEW AVATAR</button>
  </div>
}
